(function(angular){
	'use strict';

	angular
		.module('existingUserOnboardingModule')
		.controller('ExistingUserOnboarding', [
			'InvestmentEntityFactory',
			'mixpanelFactory',
			'ReitElementFactory',
			'urlFactory',
			ExistingUserOnboarding
		]);
	
	function ExistingUserOnboarding(
		InvestmentEntityFactory,
		mixpanelFactory,
		ReitElementFactory,
		urlFactory
	) {	
		var existingUserOnboarding = this;

		function submit() {
			var payload = {
				reinvestmentPreference: existingUserOnboarding.reinvestmentPreference,
				riaPlanId: existingUserOnboarding.selectedRiaPlanId
			};

			InvestmentEntityFactory.upgradeToRia(payload)
				.then(function() {
					urlFactory.submitFormById('upgradeToRia');
				});
		}

		function showValidationErrors(form) {
			angular.forEach(existingUserOnboarding[form].$error.required, function(field){
				field.$setTouched();
			});
		}

		existingUserOnboarding.back = function() {
			existingUserOnboarding.currentSlide -= 1;

			if(existingUserOnboarding.currentSlide === 0) {
				urlFactory.redirect('/existing/landing');
			}
		};

		existingUserOnboarding.ctaLabel = function() {
			return existingUserOnboarding.currentSlide === 5 ? 'Upgrade now' : 'Next';
		};

		existingUserOnboarding.next = function(formValidity, form) {
			if(existingUserOnboarding.currentSlide === 5) {
				if (!formValidity){
					showValidationErrors(form);
				} else {
					submit();
				}
			} else {
				existingUserOnboarding.currentSlide += 1;
				mixpanelFactory.track('Existing User Slide Viewed', { 'Slide number' : existingUserOnboarding.currentSlide });
			}
		};

		existingUserOnboarding.$onInit = function() {
			existingUserOnboarding.currentSlide = 1;
			existingUserOnboarding.selectedGoal = false;
			existingUserOnboarding.expandableInfo1Shown = true;
			existingUserOnboarding.expandableInfo2Shown = false;
			existingUserOnboarding.expandableInfo3Shown = false;
			existingUserOnboarding.expandableInfo4Shown = false;
			existingUserOnboarding.reinvestmentPreference = 'RIA_REINVESTMENT';

			var formats = ['flatReitElementListByStatus', 'ratingAllocations'];

			ReitElementFactory.getReitElementsForInvestmentEntity(formats)
				.then(function(reitElementLists) {
					angular.extend(existingUserOnboarding, reitElementLists);
			});
		};
	}
})(window.angular);